
interface HeroProps {
  scrollY: number;
}

export default function Hero({ scrollY }: HeroProps) {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-700 ease-out"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/5de3749ad0c20aa6952a12946939f686/bd9fb51ec9f734ddd12c0166b56a51be.png')`,
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40" />
      
      {/* Content */}
      <div className="relative z-10 flex h-full items-center justify-center">
        <div className="text-center text-white">
          <div 
            className="text-4xl md:text-6xl font-bold mb-6 tracking-[0.3em]"
            style={{ 
              opacity: Math.max(0, 1 - scrollY / 300)
            }}
          >
            MILAN
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/70 animate-bounce"
        style={{ 
          opacity: Math.max(0, 1 - scrollY / 200)
        }}
      >
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
